import { Pipe, PipeTransform } from '@angular/core';
import {IPlaylistMedia} from "@interfaces/playlist";
import {PlaylistModel} from "../../../../../models/playlist/playlist.model";

@Pipe({
  name: 'playlistSize'
})
export class PlaylistSizePipe implements PipeTransform {

  transform(plMedia: IPlaylistMedia[]): number {
    return PlaylistModel.getPlaylistSize(plMedia);
  }

}
